module.exports = __webpack_public_path__ + "img/amount_2x.958f096c.png";